import type { IEventSlot } from '@api/EventSlotsApi';

export enum EventSlotStatus {
	Open = 'open',
	AlmostFull = 'almost_full',
	Full = 'full',
	Cancelled = 'cancelled',
	NonBookable = 'non_bookable'
}

export function calculateEventSlotStatus(slot: IEventSlot): EventSlotStatus {
	if (![null, '0001-01-01T00:00:00Z'].includes(slot.canceled_at)) return EventSlotStatus.Cancelled;
	if (slot.non_bookable) return EventSlotStatus.NonBookable;
	if (slot.participant_count >= slot.participant_limit_hard) return EventSlotStatus.Full;
	if (slot.participant_count >= slot.participant_limit_soft) return EventSlotStatus.AlmostFull;

	return EventSlotStatus.Open;
}
